import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { Member } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize, underscore } from "@/utils/api-helpers";

export type CreateMemberInput = {
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
};

const createMember = async (input: CreateMemberInput): Promise<Member> => {
  const response = await api.post<Member>("/members", underscore(input));
  return camelize(response.data);
};

export const useCreateMember = (
  options: Omit<UseMutationOptions<Member, UnprocessableEntityError, CreateMemberInput, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<Member, UnprocessableEntityError, CreateMemberInput, unknown>({
    mutationFn: createMember,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["members"]
      })
    },
    ...options
  });
};
